<ng-container *ngIf="passwordState === resetPasswordState.NewPassword">
    <div class="new-password-pane shadow">
        <div [height]="30"></div>
        <div class="header-font centered-txt b1Color" i18n>{{ 'RESET_YOUR_BRIXX_PASSWORD' | translate }}</div>

        <div class="cnt-column-centered">

            <div [height]="20"></div>
            <input #passwordInput id="password" [(ngModel)]="password" (keyup)="onPasswordType()" class="default-input" type="password" name="password"
                   i18n-placeholder [placeholder]="'NEW_PASSWORD' | translate" maxlength="48" minlength="8" autocomplete="off" [height]="50"
                   (focusout)="validatePassword()"
                   data-testid="registerPass-edit-input">
            <div #passwordWrongMsg class="validation-failed-message">​</div>

            <div [height]="7"></div>

            <input #passwordConfirmInput id="passwordConfirm" [(ngModel)]="passwordConfirm" class="default-input" type="password" name="passwordConfirm"
                   i18n-placeholder [placeholder]="'CONFIRM_NEW_PASSWORD' | translate" maxlength="48" minlength="8" autocomplete="off" [height]="50"
                   (focusout)="validateConfirmPassword()"
                   data-testid="registerPass-edit-input">
            <div #passwordConfirmWrongMsg class="validation-failed-message">​</div>
            <div [height]="5"></div>

            <div #pwdHints class="pwdHints hideHints" data-testid="pwdHints">
                <div id="minLengthCheckMark" class="checkmark"></div><span i18n>8+{{ 'CHAR' | translate }}</span>
                <div id="specialCheckMark" class="checkmark"></div><span i18n>{{ 'NUMBER_SPECIAL' | translate }}</span>
                <div id="uppercaseCheckMark" class="checkmark"></div><span i18n>{{ 'UPPERCASE' | translate }}</span>
                <div id="lowercaseCheckMark" class="checkmark"></div><span i18n>{{ 'LOWERCASE' | translate }}</span>
            </div>

            <div [height]="13"></div>
            <simple-btn class="signup-btn"
                        [hoverTextColor]="'white'"
                        [backgroundFillCls]="'o2Background'"
                        [hoverFillCls]="'o1Background'"
                        [boxShadowCls]="'primary-shadow'"
                        [text]="resetPasswordButtonText | translate"
                        [textCls]="'very-large-btn-text'"
                        [height]="50"
                        [cornerRadius]="30"
                        [horizontalPadding]="20"
                        (click)="resetPassword()"
                        data-testid="trialTimerUpgradeBtn">
            </simple-btn>
        </div>

        <div [height]="57"></div>
    </div>
    <div class="bottom-links-container">
        <a class="bottom-links" (click)="goToSignIn()">Sign in</a>
    </div>
</ng-container>

<ng-container *ngIf="passwordState === resetPasswordState.PasswordChanged || passwordState === resetPasswordState.ResetPasswordExpired">
    <div class="password-changed-pane shadow">
        <div [height]="42"></div>
        <div class="header-font centered-txt b1Color">{{passwordState === resetPasswordState.PasswordChanged ? ( successPassChangeTxt | translate ) : ( failedPassChangeTxt | translate )}}</div>
        <div [height]="34"></div>
        <simple-btn class="signup-btn"
                    [hoverTextColor]="'white'"
                    [backgroundFillCls]="'o2Background'"
                    [hoverFillCls]="'o1Background'"
                    [boxShadowCls]="'primary-shadow'"
                    [text]="signInButtonText | translate"
                    [textCls]="'very-large-btn-text'"
                    [height]="50"
                    [cornerRadius]="30"
                    [horizontalPadding]="20"
                    (click)="goToSignIn()"
                    data-testid="trialTimerUpgradeBtn">
        </simple-btn>
        <div [height]="passwordState === resetPasswordState.PasswordChanged ? 57 : 72"></div>
    </div>
    <div *ngIf="passwordState === resetPasswordState.ResetPasswordExpired" class="bottom-links-container">
        <a class="bottom-links" (click)="goToForgottenPassword()" i18n>{{ 'SEND_A_NEW_PASSWORD' | translate }}</a>
    </div>
</ng-container>